export default __webpack_public_path__ + "static/media/main_1.40736732.jpg";